<template>
  <v-combobox
    v-model="zone"
    :items="zoneOptions"
    :loading="isLoading"
    :search-input.sync="search"
    hide-no-data
    auto-select-first
    item-text="ZoneName"
    item-value="ZoneName"
    :label="label"
    hide-details
    dense
    :prepend-inner-icon="mdiMapMarker"
    return-object
    no-filter
    :error-messages="errorMessages"
    outlined
    clearable
    v-on:click:clear="clear"
    @focus="searchZone()"
    :inputmode="inputmode"
    :disabled="disabled"
  ></v-combobox>
</template>

<script>
import { mdiMapMarker } from "@mdi/js";
import debounce from "lodash/debounce";
import isEmpty from 'lodash/isEmpty'
import { SelectZoneNames } from "@/api/publicServices";
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    cachedZones: {
      type: Array,
    },
    errorMessages: {
      type: String,
    },
    onChange: {
      type: Function,
    },
    hideDetails: Boolean,
    disabled: {
      type:Boolean
    }
  },
  data: () => ({
    zoneOptions: [],
    isLoading: false,
    search: null,
    zone: null,
    isClear: false,

    //svg icons
    mdiMapMarker,
  }),
  computed: {
    inputmode() {
      console.log(`mobile: ${this.$isMobile()}`);
      return  localStorage.getItem("flutter") == "true" || this.$isMobile()?"none":"text";
    },
  },
  created: function () {
    this.debouncedSearchZone = debounce(this.searchZone, 500);
    this.debouncedFilterCachedZone = debounce(this.filterCachedZones, 500);
  },
  mounted() {
    this.debouncedSearchZone("");
  },
  methods: {
    async searchZone(searchVal) {
      console.log("searchZone", searchVal);
      if (this.isClear) {
        this.isClear = false;
        return;
      }
      if (this.isLoading) return;
      if (!isEmpty(this.zone) && this.zone?.ZoneName === searchVal) return;
      this.isLoading = true;
      try {
        const response = await SelectZoneNames({ searchVal: searchVal });
        console.log(`response:${response}`);
        this.isLoading = false;
        this.zoneOptions = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    filterCachedZones(searchVal) {
      if (this.isLoading) return;
      if (searchVal.length === 0) return;
      const searchText = searchVal.toLowerCase();
      this.zoneOptions = this.cachedZones.filter((zone) => {
        return zone.ZoneName.toLowerCase().indexOf(searchText) > -1;
      });
      this.isLoading = false;
    },
    reset() {
      this.zoneOptions = [];
      this.zone = null;
    },
    clear() {
      this.isClear = true;
      console.log("isClear");
    },
  },
  watch: {
    search(newVal) {
      console.log(newVal);
      if (this.cachedZones && this.cachedZones.length > 0) {
        this.debouncedFilterCachedZone(newVal);
      } else {
        this.debouncedSearchZone(newVal);
      }
    },
    zone() {
      console.log(this.zone);
      if (this.zone === null) {
        this.$emit("input", { ZoneName: "" });
      } else {
        this.$emit("input", this.zone);
      }
    },
  },
};
</script>
